'use strict';
var builtinModules = require('builtin-modules');

module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	return builtinModules.indexOf(str) !== -1;
};



//////////////////
// WEBPACK FOOTER
// ./~/is-builtin-module/index.js
// module id = 894
// module chunks = 0